import { useQuery } from "react-query"; 
import { getTotalPeso } from "./services";

function useTotalPesoUnidades(unidades: string[]) {
  return useQuery([`/v1/unidades/total-peso`, unidades], async () => {
    if (!unidades.length) {
      return 0;
    }

    const total = await getTotalPeso(unidades);

    return total;
  });
}

export default useTotalPesoUnidades;
